const DeliveryDates = ({ diaryYear, startDate, endDate }) => (
  <p>
    <b>Inleverans</b>: {diaryYear}, {startDate} – {endDate}
  </p>
);

export default DeliveryDates;
